<template>
    <div>
        <breadcrumb :routerList="[{to:'/activity/activityInfo',title:'推广列表'},{title:'查看营销推广活动'}]"/>

        <div class="h-content">

            <div class="h-row h-mrt0">
                <div class="h-rowIn">

                    <div class="h-rowBox">
                        <el-form  ref="form1" :model="f"  >
                            <div class="h-rowCon">
                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>查看营销推广活动</h1>
                                    </div>
                                    <div class="h-pieceCon2">


                                        <div class="h-formLine ">

                                            <div class="margin-top el-descriptions">
                                                <div class="el-descriptions__body">

                                                    <table class ="meeting-table el-descriptions__table is-bordered ">

                                                        <tr>
                                                            <th colspan="13" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label" style="font-weight: bold;">基本信息</th>
                                                        </tr>

                                                        <tr v-if="f.activityType === '渠道客户会/用户会'|| f.activityType === '高校巡展/实验室安全讲座演练' ">
                                                            <th colspan="5" >
                                                                参与类型
                                                            </th>
                                                            <td colspan="8" >
                                                                <el-form-item prop="participantType">
                                                                    <el-input v-model="f.participantType"   readonly></el-input>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>


                                                        <tr>
                                                            <th colspan="5" >
                                                                省市
                                                            </th>
                                                            <td colspan="8" class=" ">
                                                                <el-form-item  prop="provinceCity" >
                                                                    <el-input v-model="f.provinceCity"   readonly></el-input>
                                                                </el-form-item>

                                                            </td>

                                                        </tr>
                                                        <tr>
                                                            <th colspan="5" >
                                                                {{ companyLabel }}
                                                            </th>
                                                            <td colspan="8">
                                                                <el-form-item prop="companyName">
                                                                    <el-input v-model="f.companyName" readonly></el-input>

                                                                </el-form-item>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <th colspan="5" >提报人姓名</th>
                                                            <td colspan="8" >
                                                                <el-form-item prop="reporterName">
                                                                    <el-input v-model="f.reporterName" readonly ></el-input>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <th colspan="5" >联系电话</th>
                                                            <td colspan="8" >
                                                                <el-form-item prop="contactPhone">
                                                                    <el-input v-model="f.contactPhone" readonly ></el-input>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <th colspan="5" >
                                                             {{eventNameLabel}}
                                                            </th>
                                                            <td colspan="8" >
                                                                <el-form-item prop="eventName">
                                                                    <el-input v-model="f.eventName" readonly ></el-input>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>

                                                        <tr v-if="f.activityType === '高校巡展/实验室安全讲座演练' ">
                                                            <th colspan="5" >
                                                                活动主题
                                                            </th>
                                                            <td colspan="8" >
                                                                <el-form-item prop="eventTheme">
                                                                    <el-input v-model="f.eventTheme" readonly ></el-input>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <th colspan="5" >
                                                                {{eventTimeLabel}}
                                                            </th>
                                                            <td  colspan="8" >
                                                                <el-form-item  prop="eventTime" >
                                                                    <el-date-picker
                                                                        readonly
                                                                        :clearable="true"
                                                                        type="date"
                                                                        value-format="yyyy-MM-dd"
                                                                        placeholder="选择时间"
                                                                        v-model="f.eventTime"
                                                                        style="width: 100%;"
                                                                    ></el-date-picker>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>

                                                    <!--通过巡检重点交互的用户名单（姓名职务电话）仅润心-->
                                                        <tr v-if="f.activityType === '润心巡检'">
                                                            <th colspan="5" >
                                                                通过巡检重点交互的用户名单（姓名职务电话）
                                                            </th>
                                                            <td colspan="8" >
                                                                <el-form-item prop="interactionUsers">
                                                                    <el-input v-model="f.interactionUsers" readonly ></el-input>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>

                                                        <!--参与人数 仅渠道会议 学术会-->
                                                        <tr v-if="f.activityType === '渠道客户会/用户会'|| f.activityType === '学术会' ">
                                                            <th colspan="5" >
                                                                {{participantCountLabel}}
                                                            </th>
                                                            <td colspan="8" >
                                                                <el-form-item prop="participantCount">
                                                                    <el-input v-model="f.participantCount" readonly ></el-input>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>
                                                        <!--展会地点 仅展会 学术会-->
                                                        <tr v-if="f.activityType === '区域展会' || f.activityType === '学术会' ">
                                                            <th colspan="5" >
                                                                {{eventLocationLabel}}
                                                            </th>
                                                            <td colspan="8" >
                                                                <el-form-item prop="eventLocation">
                                                                    <el-input v-model="f.eventLocation" readonly ></el-input>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="f.activityType === '区域展会' ">
                                                            <th colspan="5" >
                                                                展会主办方（参展费收款公司名称）
                                                            </th>
                                                            <td colspan="8" >
                                                                <el-form-item prop="eventOrganizer">
                                                                    <el-input v-model="f.eventOrganizer" readonly ></el-input>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="f.activityType === '学术会' ">
                                                            <th colspan="5" >
                                                                会议费（万）
                                                            </th>
                                                            <td colspan="8" >
                                                                <el-form-item prop="meetingFee">
                                                                    <el-input type ="number" v-model="f.meetingFee" readonly></el-input>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>


                                                        <!-------------------------- 推动在手线索 ------------------------------------>

                                                        <tr>
                                                            <th colspan="13" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label" style="font-weight: bold;">
                                                                推动在手线索
                                                            </th>
                                                        </tr>
                                                        <!-- 遍历动态线索列表，每个条目一行：漏斗编号、金额、操作 -->
                                                        <tr v-for="(detail, idx) in f.detailZSClueList" :key="'zs_' + idx">
                                                            <th  colspan="2"  style="width: 140px;">漏斗编号</th>
                                                            <td  colspan="4" >
                                                                <el-input v-model="detail.funnelCode" readonly ></el-input>
                                                            </td>
                                                            <th colspan="2" >金额</th>
                                                            <td colspan="4" >
                                                                <el-input type= 'number' v-model="detail.leadAmount" readonly></el-input>
                                                            </td>

                                                            <td class="dynamic-line-action" style="width: 100px; text-align: center;">
                                                            </td>
                                                        </tr>

                                                        <!---------------------------------- 新获取项目漏斗 (学术)------------------------------------>
                                                        <template v-if="f.activityType === '学术会'">
                                                            <tr>
                                                                <th colspan="13" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label" style="font-weight: bold;">
                                                                    新获取项目漏斗
                                                                </th>
                                                            </tr>

                                                            <!-- 遍历动态线索列表，每个条目一行：漏斗编号、金额、操作 -->
                                                            <tr v-for="(detail, idx) in f.detailNewProjectClueList" :key="'np_' + idx">
                                                                <th  colspan="2"  style="width: 140px;">漏斗编号</th>
                                                                <td  colspan="4" >
                                                                    <el-input v-model="detail.funnelCode" placeholder="请输入漏斗编号" clearable></el-input>
                                                                </td>
                                                                <th colspan="2" >金额</th>
                                                                <td colspan="4" >
                                                                    <el-input type= 'number' v-model="detail.leadAmount" placeholder="请输入金额" clearable></el-input>
                                                                </td>
                                                                <td  colspan="1" class="dynamic-line-action" style="width: 100px; text-align: center;">
                                                                </td>
                                                            </tr>

                                                        </template>


                                                        <!---------------------------------- 新获取线索 ------------------------------------>
                                                        <template v-if="f.activityType != '学术会'">
                                                            <tr>
                                                                <th colspan="13" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label" style="font-weight: bold;">新获取线索</th>
                                                            </tr>

                                                            <tr v-for="(detail, idx) in f.detailNewClueList" :key="'new_' + idx" >
                                                                <th >单位</th>
                                                                <td >
                                                                    <el-input v-model="detail.unitName" readonly></el-input>
                                                                </td>
                                                                <th >姓名</th>
                                                                <td >
                                                                    <el-input v-model="detail.contactPerson" readonly></el-input>
                                                                </td>
                                                                <th >电话</th>
                                                                <td >
                                                                    <el-input v-model="detail.contactPhone" readonly></el-input>
                                                                </td>
                                                                <th >采购需求</th>
                                                                <td >
                                                                    <el-input v-model="detail.procurementNeeds" type ="textarea" readonly></el-input>
                                                                </td>
                                                                <th v-if="f.activityType === '区域展会'">邮箱</th>
                                                                <th v-else ></th>
                                                                <td v-if="f.activityType === '区域展会'">
                                                                    <el-input v-model="detail.email" placeholder="请输入邮箱"></el-input>
                                                                </td>
                                                                <td v-else> </td>
                                                                <th >预估金额</th>
                                                                <td >
                                                                    <el-input type= 'number' v-model="detail.estimatedAmount" readonly></el-input>
                                                                </td>

                                                                <td class="dynamic-line-action" style="width: 100px; text-align: center;">
                                                                 </td>
                                                            </tr>
                                                        </template>
                                                        <!-- 新获取线索（每1万元参会费不低于20条线索） -->
                                                        <template v-if="f.activityType === '学术会'">
                                                            <tr>
                                                                <th colspan = 13 class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label" style="font-weight: bold;">新获取线索（每1万元参会费不低于20条线索）</th>
                                                            </tr>

                                                            <tbody v-for="(detail, idx) in f.detailNewClueList" :key="'new2_' + idx">
                                                            <!-- 第一行：省、市、渠道、单位、姓名、电话 -->
                                                            <tr>
                                                                <th>省</th>
                                                                <td>
                                                                    <el-input v-model="detail.province" readonly></el-input>
                                                                </td>
                                                                <th>市</th>
                                                                <td>
                                                                    <el-input v-model="detail.city" readonly></el-input>
                                                                </td>
                                                                <th>渠道</th>
                                                                <td>
                                                                    <el-input v-model="detail.channel" readonly></el-input>
                                                                </td>
                                                                <th>单位</th>
                                                                <td>
                                                                    <el-input v-model="detail.unitName" readonly></el-input>
                                                                </td>
                                                                <th>姓名</th>
                                                                <td>
                                                                    <el-input v-model="detail.contactPerson" readonly></el-input>
                                                                </td>
                                                                <th>电话</th>
                                                                <td colspan="2">
                                                                    <el-input v-model="detail.contactPhone" readonly></el-input>
                                                                </td>
                                                            </tr>
                                                            <!-- 第二行：采购需求、邮箱、预估金额、操作 -->
                                                            <tr>
                                                                <th>采购需求</th>
                                                                <td colspan="4">
                                                                    <el-input v-model="detail.procurementNeeds" type="textarea" :rows="1" readonly></el-input>
                                                                </td>
                                                                <th>邮箱</th>
                                                                <td colspan="3">
                                                                    <el-input v-model="detail.email" readonly></el-input>
                                                                </td>
                                                                <th>预估金额</th>
                                                                <td colspan="2">
                                                                    <el-input type="number" v-model="detail.estimatedAmount" readonly></el-input>
                                                                </td>
                                                                <td class="dynamic-line-action" style="text-align: center;">
                                                                </td>
                                                            </tr>
                                                            </tbody>


                                                        </template>





                                                        <!-- 仅 高校，渠道 区域 学术-->
                                                        <tr v-if="f.activityType === '高校巡展/实验室安全讲座演练'|| f.activityType === '渠道客户会/用户会' || f.activityType === '区域展会' || f.activityType === '学术会'">
                                                            <th colspan="5" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                                事前报备表(请示报告单或官方邀请函) <br/>上传PDF、EXCEL、图片等文件
                                                            </th>
                                                            <td colspan="8" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <brupload
                                                                    :refid="refid"
                                                                    reftype="activity_事前报备表"
                                                                    :showtime="false">
                                                                </brupload>
                                                            </td>

                                                        </tr>
                                                        <!-- 仅 高校，渠道 -->
                                                        <tr v-if="f.activityType === '高校巡展/实验室安全讲座演练'|| f.activityType === '渠道客户会/用户会' || f.activityType === '区域展会'">
                                                            <th colspan="5" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                                参会签到表(必须是通过电子二维码签到的表单) <br/>上传EXCEL、图片等文件
                                                            </th>
                                                            <td colspan="8" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <brupload
                                                                    :refid="refid"
                                                                    reftype="activity_参会签到表"
                                                                    :showtime="false">
                                                                </brupload>
                                                            </td>
                                                        </tr>

                                                        <!--   润心产品及数量 仅 润心   -->
                                                        <tr v-if="f.activityType === '润心巡检'">
                                                            <th colspan="5">
                                                                润心产品及数量
                                                            </th>
                                                            <td colspan="8" >
                                                                <el-form-item  prop="productQty" >
                                                                    <el-input  v-model="f.productQty" placeholder="请输入"></el-input>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>


                                                    <!--  市场销售人员是否到场具体填写( 仅润心)    -->
                                                        <tr v-if="f.activityType === '润心巡检'">
                                                            <th colspan="5">
                                                                市场销售人员是否到场具体填写
                                                            </th>
                                                            <td colspan="8" >
                                                                <el-form-item  prop="salespersonPresent" >
                                                                    <el-input v-model="f.salespersonPresent" placeholder="请输入"></el-input>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>

                                                        <!--   高校巡展    -->
                                                        <tr v-if="f.activityType === '高校巡展/实验室安全讲座演练'">
                                                            <th colspan="5" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                                活动照片(上传展示、交互、培训、演练、润心服务、合影等)<br/>上传图片
                                                            </th>

                                                            <td colspan="8" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <brupload
                                                                    :isTp = true
                                                                    :tpFlag = true
                                                                    :refid="refid"
                                                                    reftype="activity_巡展照片"
                                                                    :showtime="false">
                                                                </brupload>
                                                            </td>
                                                        </tr>

                                                        <!--   仅 润心巡检    -->
                                                        <tr v-if="f.activityType === '润心巡检'">
                                                            <th colspan="5" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                                润心照片（上传服务、交互、合影照片等）<br/>上传图片
                                                            </th>

                                                            <td colspan="8" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <brupload
                                                                    :isTp = true
                                                                    :tpFlag = true
                                                                    :refid="refid"
                                                                    reftype="activity_润心照片"
                                                                    :showtime="false">
                                                                </brupload>
                                                            </td>
                                                        </tr>
                                                        <!--   渠道客户会/用户会    -->
                                                        <tr v-if="f.activityType === '渠道客户会/用户会' ">
                                                            <th colspan="5" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                                活动照片（上传签到、展示、发布、交互、宴请等）<br/>上传图片
                                                            </th>

                                                            <td colspan="8" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <brupload
                                                                    :isTp = true
                                                                    :tpFlag = true
                                                                    :refid="refid"
                                                                    reftype="activity_活动照片"
                                                                    :showtime="false">
                                                                </brupload>
                                                            </td>
                                                        </tr>
                                                        <!--   区域展会    -->
                                                        <tr v-if="f.activityType === '区域展会' ">
                                                            <th colspan="5" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                                展会照片（上传签到、展示、发布、交互、宴请等）<br/>上传图片
                                                            </th>

                                                            <td colspan="8" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <brupload
                                                                    :isTp = true
                                                                    :tpFlag = true
                                                                    :refid="refid"
                                                                    reftype="activity_展会照片"
                                                                    :showtime="false">
                                                                </brupload>
                                                            </td>
                                                        </tr>


                                                        <!--     非学术会  -->
                                                        <tr v-if="f.activityType != '学术会'">
                                                            <th colspan="5">
                                                                其他活动效果总结
                                                            </th>
                                                            <td colspan="8" >
                                                                <el-form-item  prop="mainSummary"  >
                                                                    <el-input v-model="f.mainSummary" readonly></el-input>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>

                                                        <!--  学术会附件   -->
                                                        <template v-if="f.activityType === '学术会'">
                                                            <tr>
                                                                <th colspan="5" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                                    大会白名单（主办方提供的后台用户信息含联系方式）<br/>	上传Excel、Word、PDF、图片格式
                                                                </th>

                                                                <td colspan="8" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                    <brupload
                                                                        :refid="refid"
                                                                        reftype="activity_大会白名单"
                                                                        :showtime="false">
                                                                    </brupload>
                                                                </td>
                                                            </tr>

                                                            <tr>
                                                                <th colspan="5" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                                    现场照片（现场展位全景照片）<br/>		上传图片文件
                                                                </th>

                                                                <td colspan="8" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                    <brupload
                                                                        :isTp = true
                                                                        :tpFlag = true
                                                                        :refid="refid"
                                                                        reftype="activity_现场展位全景照片"
                                                                        :showtime="false">
                                                                    </brupload>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th colspan="5" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                                    现场照片（现场展示产品的照片） <br/>		上传图片文件
                                                                </th>

                                                                <td colspan="8" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                    <brupload
                                                                        :isTp = true
                                                                        :tpFlag = true
                                                                        :refid="refid"
                                                                        reftype="activity_现场展示产品的照片"
                                                                        :showtime="false">
                                                                    </brupload>
                                                                </td>
                                                            </tr>


                                                            <tr>
                                                                <th colspan="5" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                                    现场照片（展位桌上物料/礼品等照片） <br/>		上传图片文件
                                                                </th>

                                                                <td colspan="8" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                    <brupload
                                                                        :isTp = true
                                                                        :tpFlag = true
                                                                        :refid="refid"
                                                                        reftype="activity_礼品等照片"
                                                                        :showtime="false">
                                                                    </brupload>
                                                                </td>
                                                            </tr>

                                                            <tr>
                                                                <th colspan="5" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                                    现场照片（进入用户群的截图/加用户微信的截图） <br/>		上传图片文件
                                                                </th>

                                                                <td colspan="8" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                    <brupload
                                                                        :isTp = true
                                                                        :tpFlag = true
                                                                        :refid="refid"
                                                                        reftype="activity_加用户微信的截图"
                                                                        :showtime="false">
                                                                    </brupload>
                                                                </td>
                                                            </tr>

                                                            <tr>
                                                                <th colspan="5" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                                    现场照片（上台发言/参加晚宴/参观等照片） <br/>		上传图片文件
                                                                </th>

                                                                <td colspan="8" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                    <brupload
                                                                        :isTp = true
                                                                        :tpFlag = true
                                                                        :refid="refid"
                                                                        reftype="activity_参观等照片"
                                                                        :showtime="false">
                                                                    </brupload>
                                                                </td>
                                                            </tr>


                                                            <tr>
                                                                <th colspan="5" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                                    现场照片（其他相关赞助的见证照片，如签约、启动、颁证等 <br/>		上传图片文件
                                                                </th>

                                                                <td colspan="8" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                    <brupload
                                                                        :isTp = true
                                                                        :tpFlag = true
                                                                        :refid="refid"
                                                                        reftype="activity_启动颁证等"
                                                                        :showtime="false">
                                                                    </brupload>
                                                                </td>
                                                            </tr>


                                                            <tr>
                                                                <th colspan="5" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                                    现场竞品调研照片 <br/>	上传图片文件
                                                                </th>

                                                                <td colspan="8" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                    <brupload
                                                                        :isTp = true
                                                                        :tpFlag = true
                                                                        :refid="refid"
                                                                        reftype="activity_现场竞品调研照片"
                                                                        :showtime="false">
                                                                    </brupload>
                                                                </td>
                                                            </tr>


                                                            <tr>
                                                                <th colspan="5" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                                    竞品相关政策及新品调研
                                                                </th>

                                                                <td colspan="8" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                    <el-form-item  prop="competitionPolicy" >
                                                                        <el-input v-model="f.competitionPolicy" placeholder="请输入"></el-input>
                                                                    </el-form-item>
                                                                </td>
                                                            </tr>
                                                        </template>




                                                        <!--     仅 高校巡展， 渠道客户会/用户会 区域 学术  -->
                                                        <tr v-if="f.activityType === '高校巡展/实验室安全讲座演练'|| f.activityType === '渠道客户会/用户会' || f.activityType === '区域展会' || f.activityType === '学术会'">
                                                            <th colspan="5">
                                                                总共发生费用(元)
                                                            </th>
                                                            <td colspan="8" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <el-form-item  prop="totalExpense" >
                                                                    <el-input  type="number" v-model="f.totalExpense" readonly></el-input>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>

                                                        <!--      高校巡展， 渠道客户会/用户会 区域 学术  -->
                                                        <tr v-if="f.activityType === '高校巡展/实验室安全讲座演练'|| f.activityType === '渠道客户会/用户会' || f.activityType === '区域展会' || f.activityType === '学术会'">
                                                            <th colspan="5" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                                对应发生总费用，请上传凭证（发票、协议、合同、支付记录等）<br/>上传PDF、EXCEL、图片等文件
                                                            </th>

                                                            <td colspan="8" class="el-descriptions-item__cell el-descriptions-item__content">
                                                                <brupload
                                                                    :refid="refid"
                                                                    reftype="activity_上传费用发生凭证"
                                                                    :showtime="false">
                                                                </brupload>
                                                            </td>
                                                        </tr>

                                                        <!--   仅  润心   -->
                                                        <tr v-if="f.activityType === '润心巡检'">
                                                            <th colspan="5">
                                                                需求及建议
                                                            </th>
                                                            <td colspan="8" >
                                                                <el-form-item  prop="needsSuggestions"  >
                                                                    <el-input  v-model="f.needsSuggestions" readonly></el-input>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>


                                                    </table>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>

            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="backS">返回</el-button>

            </div>

        </div>


    </div>
</template>

<script>

import activityInfo from "@/api/loud/activity/activityInfo.js";
import ss from "@/api/SystemService";

export default {

    components: {


    },

    data() {

        return {
            searchLoading: false,
            showshdfdialog: false,
            selectDailishang: true,
            companyList: [],
            refid:this.$route.query.id,
            j:{
                jobGroup: null,
            },
            // 新增弹窗相关数据
            activityTypeDialogVisible: true, // 控制弹窗显示
            //表单
            f:{
                activityType:null,//活动类型：高校巡展 / 渠道客户会/用户会 / 润心巡检 /区域展会 默认选中第一个
                participantType: null, //参与类型  仅渠道 高校
                provinceCity:null, //省市
                companyCode:null, // 客户或经销商编码
                companyName:null, // 客户或经销商名称
                reporterName:null,//提报人姓名
                contactPhone:null,//联系电话
                eventTheme:null,//活动主题 仅高校
                eventName:null,//巡展高校（院系),润心单位 ,活动名称
                eventTime:null,//润心时间/活动时间/巡展时间
                participantCount:null,//参与人数 - 仅渠道  学术
                eventLocation:null,//展会地点- 仅展会 学术
                eventOrganizer:null,//展会主办方- 仅展会
                interactionUsers:null,//交互用户信息（姓名职务电话）-仅润心
                mainSummary:null,//其他润心效果总结/其他会议效果总结/其他巡展效果总结
                totalExpense:null,//总共发生费用
                salespersonPresent:null,//市场销售人员是否到场(润心)
                productQty:null,//润心产品及数量（润心）
                needsSuggestions:null,//需求及建议（润心）
                competitionPolicy:null,//竞品相关政策及新品调研 -仅学术
                meetingFee:null,//会议费 -仅学术
                // 推动在手线索
                detailZSClueList: [
                    { funnelCode: '', leadAmount: '' }
                ],
                // 新获取项目漏斗
                detailNewProjectClueList: [
                    { funnelCode: '', leadAmount: '' }
                ],
                // 新线索
                detailNewClueList: [
                    { unitName: '', contactPerson: '', contactPhone:'',  procurementNeeds:'', estimatedAmount:'' }
                ]

            },
            //客户名称
            companyLabel:"",
            //单位或活动名称
            eventNameLabel:"",
            //活动时间
            eventTimeLabel:"",
            //参与人数
            participantCountLabel:"",
            //展会地点
            eventLocationLabel:"",

            rules: {
                provinceCity: [{required: true, message: '请填写省市', trigger: 'blur'}],
                companyName: [{required: true, message: '请选择经销商/客户', trigger: 'change'}],
                reporterName: [{required: true, message: '请填写提报人姓名', trigger: 'blur'}],
                contactPhone: [
                    {required: true, message: '请填写联系电话', trigger: 'blur'}
                ],
                eventName: [{required: true, message: '请填写活动名称/单位', trigger: 'blur'}],
                eventTime: [{required: true, message: '请选择时间', trigger: 'change'}],
                mainSummary: [{required: true, message: '请填写会议效果总结', trigger: 'blur'}],


            },

            // 动态校验规则
            dynamicRules: {
                participantCount: [{required: true, message: '请填写参与人数', trigger: 'blur'}],
                interactionUsers: [{required: true, message: '请填写交互用户信息', trigger: 'blur'}],
                productQty: [{required: true, message: '请填写润心产品及数量', trigger: 'blur'}],
                salespersonPresent: [{required: true, message: '请填写市场销售人员是否到场', trigger: 'blur'}],
                totalExpense: [
                    {required: true, message: '请填写总共发生费用', trigger: 'blur'},
                    {pattern: /^\d+(\.\d{1,2})?$/, message: '请输入正确的金额格式', trigger: 'blur'}
                ],
                needsSuggestions: [{required: true, message: '请填写需求及建议', trigger: 'blur'}]
            }


        }
    },

    created() {
        this.query();

    },
    computed : {

    },


    methods: {

        //查询翻页
        query() {
            let id = this.$route.query.id

            activityInfo.selectById(id).then(rd => {
                this.f = rd.obj;
                this.changeActivityType( this.f.activityType);
            });
        },

        //选择活动类型
        changeActivityType(val){

            const type = val !== undefined ? val : this.f.activityType;

            if (type === '高校巡展/实验室安全讲座演练') {
                this.eventNameLabel = '活动落地高校(院系)';
                this.eventTimeLabel = '活动时间';
                this.companyLabel = '主要参与海尔经销商单位名称';

            } else if (type === '润心巡检') {
                this.companyLabel = '客户(经销商)参与单位名称';
                this.eventNameLabel = '润心单位';
                this.eventTimeLabel = '润心时间';

            }else if (type === '渠道客户会/用户会' ) {
                this.companyLabel = '主要参与海尔经销商单位名称';
                this.eventNameLabel = '活动名称';
                this.eventTimeLabel = '活动时间';
                this.participantCountLabel = '现场实际参会人数';
            }else if (type === '区域展会' ) {
                this.companyLabel = '主要参与海尔经销商单位名称';
                this.eventNameLabel = '展会名称';
                this.eventTimeLabel = '展会时间';
                this.eventLocationLabel ='展会地点';
            }else if (type === '学术会' ) {
                this.companyLabel = '主要参与海尔经销商单位名称';
                this.eventNameLabel = '会议名称';
                this.eventTimeLabel = '活动时间';
                this.participantCountLabel = '现场实际参会人数';
                this.eventLocationLabel ='地点';
            }

        },
        //返回
        backS() {
            this.$router.go(-1);
        },

    }

}


</script>
<style scoped lang="scss">
::v-deep .meeting-table  th ,td {

    text-align: center!important;
    border: 1px solid #303133!important;
    vertical-align:middle;

}
::v-deep .my-label {
    background: #fff2e5!important;

}
::v-deep .my-label-lab {
    background: #E8F5F8!important;

}
::v-deep.ljjtablepaddings1 .h-tableInput .el-input__icon{
    line-height: 0.25rem;
}

::v-deep .el-form-item {
    margin-bottom: 0 !important;
}
</style>
